import {
  EXIF_FIELDS,
  CATEGORY_METADATA,
  DEFAULT_CATEGORY_ORDER,
} from '../../config/fieldDefinitions';

export function getSelectedTargetCount(selectedIndices, selectedCellRange) {
  if (selectedCellRange) {
    return selectedCellRange.maxRow - selectedCellRange.minRow + 1;
  }

  return selectedIndices?.size || 0;
}

export function getApplyActionLabel(selectedCount, singularLabel) {
  if (selectedCount > 1) {
    return `Apply to ${selectedCount} photos`;
  }

  return singularLabel;
}

export function isGpsOnlyPreset(preset) {
  const fields = Array.isArray(preset?.includedFields) ? preset.includedFields : [];
  if (fields.length === 0) {
    return false;
  }

  return fields.every((fieldId) => fieldId === 'latitude' || fieldId === 'longitude');
}

export function filterNonGpsPresets(presets = []) {
  return presets.filter((preset) => !isGpsOnlyPreset(preset));
}

export function formatLocationCoords(latitude, longitude, precision = 4) {
  const lat = Number.parseFloat(latitude);
  const lon = Number.parseFloat(longitude);

  if (!Number.isFinite(lat) || !Number.isFinite(lon)) {
    return '--';
  }

  return `${lat.toFixed(precision)}, ${lon.toFixed(precision)}`;
}

export function buildPresetPreviewSections(preset) {
  if (!preset || !Array.isArray(preset.includedFields)) {
    return [];
  }

  const groups = new Map();

  preset.includedFields.forEach((fieldId) => {
    const field = EXIF_FIELDS[fieldId];
    if (!field) return;

    const rawValue = preset.values?.[fieldId];
    if (rawValue === null || rawValue === undefined || rawValue === '') {
      return;
    }

    const formatted = field.formatForDisplay
      ? field.formatForDisplay(rawValue)
      : rawValue;

    if (formatted === null || formatted === undefined || formatted === '' || formatted === '-') {
      return;
    }

    const categoryId = field.category || 'other';
    if (!groups.has(categoryId)) {
      groups.set(categoryId, []);
    }

    groups.get(categoryId).push({
      fieldId,
      label: field.label,
      value: String(formatted),
    });
  });

  const remainingCategoryIds = Array.from(groups.keys()).filter(
    (categoryId) => !DEFAULT_CATEGORY_ORDER.includes(categoryId),
  );

  const orderedCategoryIds = [...DEFAULT_CATEGORY_ORDER, ...remainingCategoryIds];

  return orderedCategoryIds
    .filter((categoryId) => groups.has(categoryId) && groups.get(categoryId).length > 0)
    .map((categoryId) => ({
      id: categoryId,
      label: CATEGORY_METADATA[categoryId]?.label || 'Other',
      items: groups.get(categoryId),
    }));
}
